module.exports = __webpack_public_path__ + "media/images/onecs-ecc98b298cdde17e9b682217b3a1198b.png";